import {config} from "../../config.js";
import {del, get, post, put} from "../../services/httpAdmin.js";

export let listReturnConditionTypes = async function () {
  return await get(`${config.apiUrl}/admin/return-condition-types`);
};

export let createReturnConditionType = async function (req) {
  return await post(
    `${config.apiUrl}/admin/return-condition-types`,
    JSON.stringify(req),
    "application/json",
    true
  );
};

// returnData=true so we get the JSON error body on 4xx/5xx; success returns `true` (204).
export let updateReturnConditionType = async function (id, req) {
  return await put(
    `${config.apiUrl}/admin/return-condition-types/${id}`,
    JSON.stringify(req),
    "application/json",
    true
  );
};

export let getOrderReturnConditions = async function (orderID) {
  return await get(`${config.apiUrl}/admin/orders/${orderID}/return-conditions`);
};

// setOrderReturnConditions takes an array of condition objects:
//   [{condition_type_id, order_item_id?, count?}]
// Pass an array of plain IDs and they'll be normalized for the caller's convenience.
export let setOrderReturnConditions = async function (orderID, conditions) {
  const normalized = (conditions || []).map((c) =>
    typeof c === "number" ? {condition_type_id: c} : c
  );
  return await put(
    `${config.apiUrl}/admin/orders/${orderID}/return-conditions`,
    JSON.stringify({conditions: normalized}),
    "application/json",
    false
  );
};

export let reorderReturnConditionTypes = async function (items) {
  return await put(
    `${config.apiUrl}/admin/return-condition-types`,
    JSON.stringify(items),
    "application/json",
    false
  );
};

export let reportMissingPieces = async function (req) {
  return await post(
    `${config.apiUrl}/admin/missing-pieces`,
    JSON.stringify(req),
    "application/json",
    false
  );
};

export let deleteOrderReturnCondition = async function (id) {
  return await del(
    `${config.apiUrl}/admin/order-return-conditions/${id}`,
    null,
    null,
    false
  );
};
